<app-report-item></app-report-item>
<app-report-item></app-report-item>
<app-report-item></app-report-item>
<app-report-item></app-report-item>

<div class="view-all-reports-wrap">
    <a class="view-all-reports" href="reports.html"><button class="blue-button">view all</button></a>
</div>